import React from 'react';
import { TableCell, TableRow } from "@mui/material";
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { NavLink } from "react-router-dom";
import { unitConversionHead } from "../../../../../config/constant";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import clsx from "clsx";
import { checkCRUDPermission, getColumnWidth } from '../../../../../helpers/utilities';

export const UnitConversionsTable = (props) => {
    const { onRequestSort, sortOrder, sortBy,
        details, loadMore, onDelete, onEdit,
        loadMoreContent, roleManagement } = props;

    const classes = customStyles()

    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            heads={unitConversionHead}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                            <TableCell style={{ width: getColumnWidth(unitConversionHead, 0) }}><NavLink style={{ width: getColumnWidth(unitConversionHead, 0) }} to={"#"} className={clsx(classes.color, classes.bold)} onClick={() => onEdit(data, true)}>{data?.id || '---'}</NavLink></TableCell>
                                            <TableCell style={{ width: getColumnWidth(unitConversionHead, 1) }}><span style={{ width: getColumnWidth(unitConversionHead, 1) }}>{data?.unit?.name || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(unitConversionHead, 2) }}><span style={{ width: getColumnWidth(unitConversionHead, 2) }}>{data?.toUnit?.name || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(unitConversionHead, 3) }}><span style={{ width: getColumnWidth(unitConversionHead, 3) }}>{data?.conversionFactor || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(unitConversionHead, 4) }}><span style={{ width: getColumnWidth(unitConversionHead, 4) }}>{data?.additionalFactor || '---'}</span></TableCell>
                                            <TableCell>
                                                <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                    {
                                                        roleManagement !== '' && (checkCRUDPermission('Unit Conversions', 'view', 'Younote Admin') || checkCRUDPermission('Unit Conversions', 'view', 'Admin')) &&
                                                        <NavLink to={"#"} onClick={() => onEdit(data, true)}>
                                                            <Image src={ViewIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                    {
                                                        roleManagement !== '' && (checkCRUDPermission('Unit Conversions', 'edit', 'Younote Admin') || checkCRUDPermission('Unit Conversions', 'edit', 'Admin')) &&
                                                        <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                            <Image src={EditIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                    {
                                                        roleManagement !== '' && (checkCRUDPermission('Unit Conversions', 'deletable', 'Younote Admin') || checkCRUDPermission('Unit Conversions', 'deletable', 'Admin')) &&
                                                        <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                            <Image src={DeleteIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                </Space>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                            <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                                    {'If no Units are Listed here. Please Contact Younote Admin'}
                                                </p></TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}